import { Badge } from "@/components/ui/badge"

interface AdimplenciaTagProps {
  isInadimplente?: boolean | null
}

export const AdimplenciaTag = ( { isInadimplente }: AdimplenciaTagProps ) => {
  if ( isInadimplente === null || isInadimplente === undefined ) {
    return null
  }

  if ( isInadimplente ) {
    return (
      <Badge variant="destructive">
        Inadimplente
      </Badge>
    )
  }

  return (
    <Badge variant="success">
      Adimplente
    </Badge>
  )
}
